import { useToggle } from "../../../hooks/useToggle.js";
import { LabeledInputControlsButton } from "./LabeledInputControlsButton.js";
import { useOnClickOutside } from "../../../hooks/useOnClickOutside.js";
import { LabeledInputDisplay } from "./LabeledInputDisplay.js";
import { useRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/shared/LabeledInput/LabeledInput.tsx
function LabeledInput({ displayOnly = false, inputElement, label, nameElement, onCancel, onComplete, value }) {
	const [showInput, toggleShowInput] = useToggle(false);
	const inputRef = useRef(null);
	useOnClickOutside(inputRef, toggleShowInput);
	if (showInput) return /* @__PURE__ */ jsx("div", {
		ref: inputRef,
		children: /* @__PURE__ */ jsxs("div", {
			className: "gap-x-xxs inline-flex h-10 w-full items-center",
			children: [/* @__PURE__ */ jsx("div", {
				className: "w-full",
				children: inputElement
			}), (!!onCancel || !!onComplete) && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(LabeledInputControlsButton, {
				onCancel: onCancel ? () => {
					onCancel();
					toggleShowInput();
				} : void 0,
				onComplete: onComplete ? () => {
					onComplete();
					toggleShowInput();
				} : void 0
			}) })]
		})
	});
	return /* @__PURE__ */ jsx(LabeledInputDisplay, {
		displayOnly,
		showInput,
		label,
		nameElement,
		toggleShowInput,
		value
	});
}
//#endregion
export { LabeledInput };

//# sourceMappingURL=LabeledInput.js.map